import { useSyncExternalStore } from "react";

export interface ClientDetailsFill {
  identification?: string;
  addressLine1?: string;
  addressLine2?: string;
  zipCode?: string;
  city?: string;
  email?: string;
  phone?: string;
}

export interface ClientDetailsFillOutcome {
  filled: (keyof ClientDetailsFill)[];
  held: (keyof ClientDetailsFill)[];
}

export type ClientDetailsFillTarget = (fill: ClientDetailsFill) => ClientDetailsFillOutcome;

export function offerClientDetailsFill(target: ClientDetailsFillTarget): () => void {
  current = target;
  notify();
  return () => {
    if (current !== target) return;
    current = null;
    notify();
  };
}

export function clientDetailsFillTarget(): ClientDetailsFillTarget | null {
  return current;
}

export function useClientDetailsFillOffered(): boolean {
  return useSyncExternalStore(subscribe, offered, offered);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function offered(): boolean {
  return current !== null;
}

function notify(): void {
  for (const listener of listeners) listener();
}

const listeners = new Set<() => void>();
let current: ClientDetailsFillTarget | null = null;
